import React from "react";
import {
  MdOutlineCalendarToday,
  MdOutlineMedicalServices,
  MdOutlineDescription,
  MdOutlineAccessTime,
} from "react-icons/md";

const DoctortOverview = ({ doctorViewData }) => {
  const educationData = [
    {
      university: "Harvard Medical School",
      qualification: "Doctor of Medicine (MD)",
      fieldOfStudy: "Neurology",
      percentage: "92%",
      startDate: "15-Aug-2005",
      lastDate: "20-May-2009",
      certifications:
        "Board Certified Neurologist with specialization in Epilepsy and Stroke. Completed Advanced Clinical Training in Neurophysiology. Member of the American Academy of Neurology.",
    },
    {
      university: "AIIMS, Delhi",
      qualification: "MBBS",
      fieldOfStudy: "General Medicine",
      percentage: "89%",
      startDate: "01-Jul-1999",
      lastDate: "15-Mar-2004",
      certifications:
        "Completed MBBS with honors. Attended multiple clinical rotations across departments. Received 'Best Intern Award' in final year.",
    },
    {
      university: "Johns Hopkins University",
      qualification: "Fellowship",
      fieldOfStudy: "Clinical Neurophysiology",
      percentage: "95%",
      startDate: "01-Sep-2010",
      lastDate: "30-Jun-2012",
      certifications:
        "Specialized training in EEG, EMG, and epilepsy diagnosis. Published two peer-reviewed papers on brain wave patterns. Accredited by the American Board of Psychiatry and Neurology.",
    },
  ];

  return (
    <div className="mt-2 space-y-6">
      {/* Doctor Summary */}
      <div className="text-black">
        <div className="flex flex-col space-y-1.5 p-4">
          <h2 className="text-xl xl:text-2xl font-semibold leading-tight mb-2 tracking-tight">
            Education & Certifications
          </h2>
        </div>

        <div className="p-4 space-y-6">
          {/* Education Section */}
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {doctorViewData?.eductioncertificates?.map((edu, index) => (
                <div
                  key={index}
                  className="border rounded-xl shadow-sm p-5 bg-white text-gray-800 space-y-2"
                >
                  <h3 className="text-lg font-semibold text-primary">
                    {edu.qualification}
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    <strong>University:</strong> {edu.university}
                  </p>
                  <p className="text-sm text-muted-foreground">
                    <strong>Field of Study:</strong> {edu.fieldofStudy}
                  </p>
                  <p className="text-sm text-muted-foreground">
                    <strong>Percentage:</strong> {edu.percentages}%
                  </p>
                  <p className="text-sm text-muted-foreground">
                    <strong>Duration:</strong>{" "}
                    {edu.startdate &&
                      new Date(edu.startdate)
                        .toLocaleDateString("en-GB", {
                          month: "short",
                          year: "numeric",
                        })
                        .replace(" ", "-")}{" "}
                    –{" "}
                    {edu.lastdate &&
                      new Date(edu.lastdate)
                        .toLocaleDateString("en-GB", {
                          month: "short",
                          year: "numeric",
                        })
                        .replace(" ", "-")}
                  </p>


                  <div className="text-sm">
                    <strong>Certifications:</strong>
                    <p className="mt-1 text-gray-600">{edu.certifications}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Recent Appointments */}
          {/* <div className="space-y-4">
            <h3 className="text-lg font-medium">Recent Appointments</h3>
            <div className="space-y-3">
              <AppointmentCard
                title="Check-up"
                date="2023-07-15"
                time="10:00 AM"
                doctor="Dr. Sarah Johnson"
              />
              <AppointmentCard
                title="Follow-up"
                date="2023-08-22"
                time="2:30 PM"
                doctor="Dr. Michael Chen"
              />
              <AppointmentCard
                title="Check-up"
                date="2023-10-05"
                time="11:15 AM"
                doctor="Dr. Sarah Johnson"
              />
            </div>
            <button className="text-[#171717] w-full h-10 px-4 py-2 text-sm font-medium border rounded-md bg-white hover:bg-gray-50">
              View All Appointments
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

const SummaryBox = ({ icon, title, lines, action }) => (
  <div className="rounded-lg border bg-white text-black shadow-sm p-4">
    <div className="flex items-center text-base font-semibold mb-2">
      {icon} {title}
    </div>
    <ul className="text-sm text-gray-700 space-y-1">
      {lines.map((line, idx) => (
        <li key={idx}>{line}</li>
      ))}
    </ul>
    {action && (
      <div className="mt-2 text-sm text-blue-600 hover:underline cursor-pointer">
        {action}
      </div>
    )}
  </div>
);

const AppointmentCard = ({ title, date, time, doctor }) => (
  <div className="flex items-center justify-between p-3 border rounded-md flex-wrap gap-3">
    <div className="flex items-start gap-3">
      <div className="h-2 w-2 mt-2 rounded-full bg-green-500"></div>
      <div>
        <p className="font-medium">{title}</p>
        <div className="flex items-center text-sm text-gray-500">
          <MdOutlineCalendarToday className="mr-1 h-3 w-3" /> {date}
          <MdOutlineAccessTime className="ml-2 mr-1 h-3 w-3" /> {time}
        </div>
        <p className="text-sm text-gray-500">{doctor}</p>
      </div>
    </div>
    <div className="inline-flex items-center rounded-full bg-green-500 text-white px-2.5 py-0.5 text-xs font-semibold">
      Completed
    </div>
  </div>
);

export default DoctortOverview;
